import React, { Component } from "react";
import PropTypes from "prop-types";
import { Redirect } from "react-router-dom";

import { connect } from "react-redux";

// Material imports
import withStyles from "@material-ui/core/styles/withStyles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";

// Util
import PostSkeleton from "../util/PostSkeleton";
import Post from "../components/post/Post";

import { getSavedPosts } from "../redux/actions/dataActions";

import axios from "axios";
import { LOADING_POSTS, STOP_LOADING_POSTS } from "../redux/types";
import store from "../redux/store";

const styles = (theme) => ({
  ...theme.spreadThis,
});

class wardrobe extends Component {

  state = {
    sPosts: "none"
  }

  async getSavedPs () {
    const listofsavedPosts = {
      // postIds: this.props.user.credentials.savedPosts,
      postIds: this.props.user.savedPosts,
    };
    //console.log(listofsavedPosts);
    //var posts = [];
    // if(listofsavedPosts.length !== 0 && listofsavedPosts !== undefined)
    // {
    //   //var sP = await this.props.getSavedPosts(listofsavedPosts);
    // //console.log(sP);
    // this.setState({sPosts: "blah"})
    // }
    await this.setState({sPosts: "working"})
    console.log(listofsavedPosts);
    if(listofsavedPosts.postIds.length !== 0) {
      
      store.dispatch({ type: LOADING_POSTS });
    await axios
      .post("/savedPosts", listofsavedPosts)
      .then((res) => {
        console.log(res.data);
        store.dispatch({ type: STOP_LOADING_POSTS })
        this.setState({sPosts: res.data})
      })
      .catch((err) => {
        console.log(err);
      });
    }
    else {
      this.setState({sPosts: []})
    }
  };

  
  render() {
    const {
      classes,
      user: {
        //credentials,
        //loading,
        authenticated,
      },
      UI: { loadingPosts },
    } = this.props;
    // if(this.state.sPosts === "none" && this.props.user.credentials.savedPosts !== undefined)
    if(this.state.sPosts === "none")// && this.props.user.savedPosts !== undefined && loadingPosts)
    {
      this.getSavedPs();
      
    }
    console.log(this.state.sPosts);
    var savedPosts = this.state.sPosts;
    const wardrobePosts = loadingPosts || savedPosts === "none" ? (
      <PostSkeleton />
    ) : authenticated ? (
      savedPosts.length === 0 ? (
        <div className={styles.root}>
          <Grid container>
            <Paper className={styles.paper}>
              <h4>No saved posts from this user</h4>
            </Paper>
          </Grid>
        </div>
      ) : savedPosts !== "working" ? (
        // TODO: make a backend api route same as getAllPosts called getSavedPosts that takes in an array of PostIds and then returns the information in the posts. Use axios and call it here, and then display the information using the <Post with the key=postId, and the post={post}.
        // console.log(savedPosts)
        savedPosts.map((post) => <Post key={post.postId} post={post} />)
      ) : []
      ) : (
        <Redirect to="/login" /> 
        );
    

    // const wardrobePosts = loading ? (
    //   <PostSkeleton />
    // ) : savedPosts === null || savedPosts.length === 0 ? (
    //   <div className={styles.root}>
    //     <Grid container>
    //       <Paper className={styles.paper}>
    //         <h4>No saved posts from this user</h4>
    //       </Paper>
    //     </Grid>
    //   </div>
    // ) : !postIdParam ? (
    //   posts.map((post) => <Post key={post.postId} post={post} />)
    // ) : (
    //   posts.map((post) => {
    //     if (post.postId !== postIdParam)
    //       return <Post key={post.postId} post={post} />;
    //     else return <Post key={post.postId} post={post} openDialog />;
    //   })
    // );

    return (
      <Grid container className={classes.form}>
        <Grid item sm />
        <Grid item sm>
          {wardrobePosts}
        </Grid>
        <Grid item sm />
      </Grid>
    );
  }
}

wardrobe.propTypes = {
  user: PropTypes.object.isRequired,
  data: PropTypes.object.isRequired,
  UI: PropTypes.object.isRequired,
  getSavedPosts: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  classes: PropTypes.object.isRequired,
  user: state.user,
  data: state.data,
  UI: state.UI,
});

export default connect(mapStateToProps, { getSavedPosts })(withStyles(styles)(wardrobe));
